import axiosInstance from "./axiosInstance";

type GiveUserCoinsPayload = {
  selectedIds: number[];
  coins: number;
};

const sendCoins = async (formData: GiveUserCoinsPayload) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const res = await axiosInstance.post("/api/giveUserCoins", formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || error.message || "Error sending coins";
    throw new Error(errorMessage);
  }
};

export default sendCoins;
